import { Building2, X } from "lucide-react";
import { useT, useDeptName } from "@/contexts/LanguageContext";
import { DEPT_ICONS } from "@/utils/constants";

const DashboardView = ({ departments, onDepartmentClick, onToggleNA, clientId, selectedAssetName }) => {
  const t = useT();
  const dn = useDeptName();

  // A building with no (asset, department) memberships is a normal state, not
  // an error: memberships are established by the real ingest paths, so a
  // freshly created asset legitimately has none. Explain that instead of
  // rendering an empty grid that looks like a failed load.
  if (departments.length === 0) {
    return (
      <div data-testid="dashboard-view">
        <div className="page-header">
          <h2 className="page-title">{t("select_department")}</h2>
          <p className="page-subtitle">{t("select_department_subtitle")}</p>
        </div>
        <div className="empty-state" data-testid="dept-grid-empty">
          <div className="empty-state-icon"><Building2 size={32} /></div>
          <h3 className="empty-state-title">{t("no_departments_title")}</h3>
          <p className="empty-state-text">
            {selectedAssetName
              ? t("no_departments_for_asset").replace("{asset}", selectedAssetName)
              : t("no_departments_for_client")}
          </p>
        </div>
      </div>
    );
  }

  return (
  <div data-testid="dashboard-view">
    <div className="page-header">
      <h2 className="page-title">{t("select_department")}</h2>
      <p className="page-subtitle">{t("select_department_subtitle")}</p>
    </div>
    <div className="department-grid">
      {departments.map((dept) => {
        const DeptIcon = DEPT_ICONS[dept.key] || Building2;
        const isNA = dept.not_applicable;
        return (
          <div key={dept.key} className={`department-card ${isNA ? "department-na" : ""}`} data-testid={`dept-card-${dept.key}`}>
            <div className="department-card-top" onClick={() => !isNA && onDepartmentClick(dept)}>
              <div className="department-card-icon"><DeptIcon size={28} /></div>
              <h3 className="department-card-title">{dn(dept.key)}</h3>
              {isNA ? (
                <span className="badge badge-na">{t("not_applicable")}</span>
              ) : (
                <div className="department-card-status">
                  <span className={`badge badge-${dept.status === "completed" ? "success" : dept.status === "in_progress" ? "warning" : "neutral"}`}>
                    {dept.status === "completed" ? t("completed") : dept.status === "in_progress" ? t("in_progress") : t("not_started")}
                  </span>
                </div>
              )}
              {!isNA && (
                <>
                  <div className="progress-bar">
                    <div className={`progress-fill ${dept.completion_percentage === 100 ? "success" : ""}`} style={{ width: `${dept.completion_percentage}%` }}></div>
                  </div>
                  <div className="text-muted mt-sm" style={{ fontSize: "var(--text-small)" }}>{dept.completion_percentage}% {t("complete")}</div>
                </>
              )}
            </div>
            <div
              className={`department-na-toggle ${isNA ? "active" : ""}`}
              onClick={(e) => { e.stopPropagation(); onToggleNA(dept.key, !isNA); }}
              data-testid={`na-toggle-${dept.key}`}
            >
              <div className={`na-checkbox ${isNA ? "checked" : ""}`}>
                {isNA && <X size={12} />}
              </div>
              <span>{t("not_applicable")}</span>
            </div>
          </div>
        );
      })}
    </div>
  </div>
  );
};

export default DashboardView;
